<template>
    <b-badge class="e-status-badge" :variant="variant" :class="size" :pill="pill">
        <i class="fas fa-fw mr-1" :class="glyphComputed"/>
        <slot></slot>
    </b-badge>
</template>

<script>
export default {
    name: `e-status-badge`,
    props: {
        value: { type: [String, Boolean] },
        size: { type: String, default: `md` },
        glyph: { type: String },
        pill: { type: Boolean },
        status: { type: String }
    },
    computed: {
        glyphComputed() {
            if (this.glyph) {
                return this.glyph;
            }

            if (this.status === `success` || this.status === `valid` || this.status === `active` || this.value === true) {
                return `fa-circle-check`;
            } else if (this.status === `warning` || this.status === `info`) {
                return `fa-circle-exclamation`;
            } else if (this.status === `deleted`) {
                return `fa-trash`;
            } else if (this.status === `danger` || this.status === `inactive` || this.value === false) {
                return `fa-circle-xmark`;
            } else {
                return `fa-square-question`;
            }
        },
        variant() {
            if (this.status === `success` || this.status === `valid` || this.status === `active` || this.value === true) {
                return `light-success`;
            } else if (this.status === `info`) {
              return `light-info`;
            } else if (this.status === `warning`) {
                return `light-warning`;
            } else if (this.status === `danger` || this.status === `inactive` || this.status === `expired` || this.status === `deleted` || this.value === false) {
                return `light-danger`;
            } else {
              return this.status;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
